<template>
  <div class="w-100 mb-4">
    <div class="container-fluid px-2">
      <div class="row align-items-center mb-3 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start"
          >
            <span class="carousel_title_new">New Released Podcasts</span>
            <div
              class="d-flex flex-row align-items-center ml-3 view-all-wrapper"
              @click="viewMore()"
            >
              <span class="see-more-text cursor-pointer">View All</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-0 latest-tv-rails-content" id="latestPodcastCarousel">
        <div class="owl-carousel owl-theme" id="latestpodcastcarousel">
          <div
            class="item"
            v-for="item_podcast in podcast"
            :key="item_podcast.id"
          >
            <podcastCard
              :image="item_podcast.img_link"
              :latestTag="item_podcast.shownewimage"
              :title="formatString(item_podcast.longTitle)"
              :description="item_podcast.data.description"
              :link="item_podcast.redirect_url"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import podcastCard from "../cards/v2/podcastEpsCard.vue";
import axios from "axios";
export default {
  data: function() {
    return {
      podcast: [],
    };
  },
  components: { podcastCard },
  methods: {
    viewMore() {
      this.$router.push("/podcast/");
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: true,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-lg"></span>',
          '<span class="fa fa-chevron-right fa-lg"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            loop: false,
            margin: 8,
            stagePadding: 8,
          },
          480: {
            items: 2,
            nav: true,
            loop: false,
            margin: 8,
            stagePadding: 12,
          },
          720: {
            items: 3,
            nav: true,
            loop: false,
            margin: 12,
            stagePadding: 20,
          },
          992: {
            items: 3,
            stagePadding: 0,
            loop: false,
            margin: 12,
          },
        },
      });
    },

    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;
      var checkImgFeature =
        item.data && item.data.images && item.data.images.feature;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else {
          if (checkImgFeature) {
            imgurl =
              "https://rtb-images.glueapi.io/320x0/" +
              item.data.images.feature.path;
          } else {
            imgurl =
              "https://cdn-rtb.glueapi.io/v1/content/" +
              item.id +
              "/image/300x0/images.title";
          }
        }
      }
      return imgurl;
    },

    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      // console.log(JSON.stringify(item,null,2));

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (item.idSchema == "204") {
        //pod episode
        // get main podcast id id=382&eps_id=385
        var podcast_id = item.data.podcast.id;
        link = "/podcastplayer?id=" + podcast_id + "&eps_id=" + item.id;
        // console.log(link);
      }

      return link;
    },

    formatTimestamp(dt) {
      var result;
      var t = new Date(dt);
      var dtplustwo =
        t.getFullYear() +
        "-" +
        (t.getMonth() + 1) +
        "-" +
        (t.getDate() + 2) +
        " 00:00";
      dtplustwo = new Date(dtplustwo).getTime();
      // console.log(t);
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " 00:00";

      var twodays =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() + 2) +
        " 00:00";
      var from = new Date(date).getTime(); //today
      var twodaysafter = new Date(twodays).getTime(); //twodaysfromtodaay
      if (dtplustwo >= from && dtplustwo <= twodaysafter) {
        result = true;
      } else {
        result = false;
      }

      return result;
    },

    async organizeData(obj) {
      var vm = this;
      var store = [];

      obj.forEach((item, index) => {
        var timecompare = this.formatTimestamp(item.dateAvailability);
        var redirectLink = this.checkLink(item);
        item["img_link"] = this.imgFiltering(item);
        item["shownewimage"] = timecompare;
        item["redirect_url"] = redirectLink;
        store.push(item);

        if (index == obj.length - 1) {
          store.sort(function(a, b) {
            return b.dateAvailability - a.dateAvailability;
          });
        }
      });

      vm.podcast = store.slice(0, 8);

      Vue.nextTick(
        function() {
          vm.installOwlCarousel("#latestpodcastcarousel");
        }.bind(vm)
      );
    },
    async onInitializeContentForStart() {
      axios
        .get(
          `https://rtb.glueapi.io/v1/content?idSchema=204&limit=10&sort=-dateAvailability`
        )
        .then((response) => {
          this.organizeData(response.data.data);
        });
    },
  },
  beforeMount() {
    this.onInitializeContentForStart();
  },
};
</script>

<!-- new -->

<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#latestPodcastCarousel .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #latestPodcastCarousel .owl-theme:hover {
    z-index: 111;
  }

  #latestPodcastCarousel .owl-theme {
    height: auto;
  }
  #latestPodcastCarousel .owl-item {
    z-index: 1;
  }
  #latestPodcastCarousel .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #latestPodcastCarousel .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #latestPodcastCarousel .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #latestPodcastCarousel .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #latestPodcastCarousel .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #latestPodcastCarousel .owl-next span,
  #latestPodcastCarousel .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
